import Axios from 'axios';
import Promise from 'bluebird';
import _ from 'lodash';
import URL from './apiUrl';

import fetchAdapter from 'axios/lib/adapters/fetch';
//import httpAdapter from 'axios/lib/adapters/http';
//import xhrAdapter from 'axios/lib/adapters/xhr';
import settle from 'axios/lib/core/settle';

const customAdapter = config => {
  return new Promise((resolve, reject) => {
    fetchAdapter(config)
      .then((response) => {
        settle(resolve, reject, response);
      })
      .catch(reject);
  });
}

Promise.config({
    warnings: false,
    longStackTraces: false,
    cancellation: true,
});

const getClient = () => {
    const options = {
        baseURL: URL.BACKEND_URL,
        withCredentials: true,
        adapter: customAdapter,
    };
    const client = Axios.create(options);
    return client;
};

let client = getClient();

class Api {

    constructor() {
        this.baseURL = URL.BACKEND_URL;
    }
    
    newClient() {
        this.client = getClient();
        return this;
    }

    getClient() {
        this.client = this.client || client;
        return this.client;
    }

    prepareRequestData(params, useBlankValues) {
        return useBlankValues
            ? _.transform(params, (r, v, k) => { r[k] = (v === false ? 0 : (v === true ? 1 : (v === undefined ? null : v)))})
            : _.pickBy(params, (v, k) => Object.prototype.hasOwnProperty.call(params, k) && !['', false].includes(v));
    }

    get (url, params = {}, useBlankValues = false) {
        const requestData = this.prepareRequestData(params, useBlankValues);

        return this.request({
            url: url,
            method: 'get',
            params: requestData
        })
    }

    post (url, params = {}, useBlankValues = false) {
        const requestData = this.prepareRequestData(params, useBlankValues);

        return this.request({
            url: url,
            method: 'post',
            data: requestData
        });
    }

    postFile (url, fileObject, fieldName = 'file') {
        if (!fileObject) {
            return new Promise((resolve, reject) => {
                reject('Нет данных для сохранения');
            });
        }
        const data = new FormData();
        data.append(fieldName, fileObject, fileObject.name);
        return this.request({
            url: url,
            method: 'post',
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
    }

    delete (url, params = {}, useBlankValues = false) {
        const requestData = this.prepareRequestData(params, useBlankValues);
        return this.request({
            url: url,
            method: 'delete',
            data: requestData
        })
    }

    put (url, params = {}, useBlankValues = false) {
        const requestData = this.prepareRequestData(params, useBlankValues);
        return this.request({
            url: url,
            method: 'put',
            data: requestData
        })
    }

    patch (url, params = {}, useBlankValues = false) {
        const requestData = this.prepareRequestData(params, useBlankValues);
        return this.request({
            url: url,
            method: 'patch',
            data: requestData
        })
    }

    request (configRequest) {
        return new Promise((resolve, reject, onCancel) => {
            const cancelSource = Axios.CancelToken.source();
            const cancelToken = Object.prototype.hasOwnProperty.call(configRequest, 'cancelToken') ? configRequest.cancelToken : cancelSource.token;
            const requestConfig = {...configRequest, ...{ cancelToken }};
            onCancel(() => {
                cancelSource.cancel()
            });
            const client = this.getClient();
            return client.request(requestConfig)
                .then((...args) => {
                    return configRequest.transformResponse ? resolve(configRequest.transformResponse(...args)) : resolve(...args);
                })
                .catch((...args) => { 
                    return reject(...args);
                })
        });
    }

    getResource(url) {
        return new Promise((resolve, reject) => {
            this.request({
                url,
                method: 'get',
                responseType: 'blob',
            }).then(resp => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = err => reject(err);
                reader.readAsDataURL(resp);
            }).catch(err => reject(err));
        });
    }

}

export default new Api()
